import type { CodePatch } from '../services/types'

export function executeCodePatch(code: string, patch: CodePatch): string {
  const lines = code.split('\n')
  const start = patch.start_line - 1
  const deleteCount = patch.end_line - patch.start_line + 1
  const newLines = patch.new_code ? patch.new_code.split('\n') : []
  lines.splice(start, deleteCount, ...newLines)
  return lines.join('\n')
}
